import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16bf89d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_layout" }
const _hoisted_2 = { class: "main_content" }
const _hoisted_3 = { class: "content_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lianmengDialog" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("1、代理商每天的有效结算量低于"),
    /*#__PURE__*/_createElementVNode("span", null, "300"),
    /*#__PURE__*/_createTextVNode("个不结算。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("2、子渠道每天的有效结算量低于"),
    /*#__PURE__*/_createElementVNode("span", null, "100"),
    /*#__PURE__*/_createTextVNode("个不结算。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("3、新上线代理商渠道测试期为"),
    /*#__PURE__*/_createElementVNode("span", null, "15"),
    /*#__PURE__*/_createTextVNode("天，若测试期不达标不签署合同且不结算。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("4、各代理商每周拿包不得超过"),
    /*#__PURE__*/_createElementVNode("span", null, "3"),
    /*#__PURE__*/_createTextVNode("个，每个代理商总安装包数不得超过"),
    /*#__PURE__*/_createElementVNode("span", null, "15"),
    /*#__PURE__*/_createTextVNode("个。")
  ])
], -1))
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("OK")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_Aside = _resolveComponent("Aside")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserInfo),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Aside),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.adjustDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adjustDialogVisible) = $event)),
      title: "毒霸联盟提示"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.adjustDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}